export const stateList = [
  { name: "Jammu And Kashmir", _id: "Jammu And Kashmir" },
  { name: "Himachal Pradesh", _id: "Himachal Pradesh" },
  { name: "Punjab", _id: "Punjab" },
  { name: "Chandigarh", _id: "Chandigarh" },
  { name: "Uttarakhand", _id: "Uttarakhand" },
  { name: "Haryana", _id: "Haryana" },
  { name: "Delhi", _id: "Delhi" },
  { name: "Rajasthan", _id: "Rajasthan" },
  { name: "Uttar Pradesh", _id: "Uttar Pradesh" },
  { name: "Bihar", _id: "Bihar" },
  { name: "Sikkim", _id: "Sikkim" },
  { name: "Arunachal Pradesh", _id: "Arunachal Pradesh" },
  { name: "Nagaland", _id: "Nagaland" },
  { name: "Manipur", _id: "Manipur" },
  { name: "Mizoram", _id: "Mizoram" },
  { name: "Tripura", _id: "Tripura" },
  { name: "Meghalaya", _id: "Meghalaya" },
  { name: "Assam", _id: "Assam" },
  { name: "West Bengal", _id: "West Bengal" },
  { name: "Jharkhand", _id: "Jharkhand" },
  { name: "Orissa", _id: "Orissa" },
  { name: "Chhattisgarh", _id: "Chhattisgarh" },
  { name: "Madhya Pradesh", _id: "Madhya Pradesh" },
  { name: "Gujarat", _id: "Gujarat" },
  { name: "Daman And Diu", _id: "Daman And Diu" },
  { name: "Dadra And Nagar Haveli", _id: "Dadra And Nagar Haveli" },
  { name: "Maharashtra", _id: "Maharashtra" },
  { name: "Karnataka", _id: "Karnataka" },
  { name: "Goa", _id: "Goa" },
  { name: "Lakshadweep Islands", _id: "Lakshadweep Islands" },
  { name: "Kerala", _id: "Kerala" },
  { name: "Tamil Nadu", _id: "Tamil Nadu" },
  { name: "Pondicherry", _id: "Pondicherry" },
  { name: "Andaman and Nicobar Islands", _id: "Andaman and Nicobar Islands" },
  { name: "Telangana", _id: "Telangana" },
  { name: "Andhra Pradesh (New)", _id: "Andhra Pradesh (New)" },
  { name: "Ladakh", _id: "Ladakh" },
];
